// Styles
import '@fortawesome/fontawesome-free/css/all.css'
import '@mdi/font/css/materialdesignicons.css'
import {aliases, fa} from 'vuetify/iconsets/fa'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify(
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  {
    theme: {
      defaultTheme: 'dark',
      themes: {
        dark: {
          dark: true,
          colors: {
            primary: '#DAA520',
            secondary: '#212121',
            background: '#000000',
            surface: '#121212',
          },
        },
      },
    },
    icons: {
      defaultSet: 'fa',
      aliases,
      sets: {
        fa,
      }
    },
  }
)
